import { AfterViewChecked, Directive, ElementRef } from '@angular/core'

@Directive({
  selector: '[mbOpenLinkInNewTab]'
})
export class MbOpenLinkInNewTabDirective implements AfterViewChecked {

  constructor (private el: ElementRef) {
  }
  ngAfterViewChecked (): void {
    Array.from(this.el.nativeElement.querySelectorAll('a'))
      .forEach((el: any) => {
        el.setAttribute('target', '_blank')
      })
  }

}
